import { render, staticRenderFns } from "./MemberBadgeListParts.vue?vue&type=template&id=401149c0&scoped=true"
import script from "./MemberBadgeListParts.vue?vue&type=script&lang=ts"
export * from "./MemberBadgeListParts.vue?vue&type=script&lang=ts"
import style0 from "./MemberBadgeListParts.vue?vue&type=style&index=0&id=401149c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401149c0",
  null
  
)

export default component.exports